export default "__VITE_ASSET__CWZbGcTH__"